import * as angular from "angular";
import {IQService, IWindowService} from "angular";

export class ResizerService {
  constructor(private $window: IWindowService, private $q: IQService) {
  }

  onHorizontalMove(event) {
    const windowSize = this.$window.innerWidth;
    const leftFlexPercentage = Math.floor((event.clientX * 100) / windowSize);
    const rightFlexPercentage = 100 - leftFlexPercentage;
    const flex = {
      left: leftFlexPercentage + '%',
      right: rightFlexPercentage + '%'
    };

    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();

    event.cancelBubble = true;
    event.returnValue = false;

    return this.$q.all(flex);
  }

  onVerticalMove(event) {
    const windowSize = this.$window.innerHeight;
    const upFlexPercentage = Math.floor((event.clientY * 100) / windowSize);
    const downFlexPercentage = 100 - upFlexPercentage;
    const flex = {
      down: downFlexPercentage + '%',
      up: upFlexPercentage + '%'
    };

    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();

    event.cancelBubble = true;
    event.returnValue = false;

    return this.$q.all(flex);
  }

}

angular
  .module('bringoz.admin.commons')
  .service('resizerService', ResizerService);
